import { Component, forwardRef, ViewChild, ElementRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator } from '@angular/forms';

@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PhoneInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PhoneInputComponent),
            multi: true
        }
    ]
})
export class PhoneInputComponent implements ControlValueAccessor, Validator {
    @Input()
    required: boolean = false;

    @ViewChild('phoneInput')
    phoneInput: ElementRef;

    readonly dialingCode: string = '+44';

    phoneNumber: string;
    mask = [/\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

    onChange = (_: any) => {};
    onTouched = () => {};

    inputChanged() {
        this.onChange(this.dialingCode + this.phoneNumber);
    }

    writeValue(value: string) {
        if (value !== null && value !== undefined) {
            this.phoneNumber = value.replace(this.dialingCode, '');
            this.inputChanged();
        } else {
            this.phoneNumber = '';
            this.phoneInput.nativeElement.value = '';
        }
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    validate(control: any): { [key: string]: any } {
        if (this.required && this.phoneNumber !== undefined && this.phoneNumber.length === 0) {
            return { required: true };
        }
        return this.phoneInput.nativeElement.validity.valid
            ? null
            : {
                  invalid: true
              };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/phone-input/phone-input.component.ts